
import {db} from '../firebaseConfig';

import { doc, getDoc, setDoc } from 'firebase/firestore';

export async function generateUniqueId(itemType,accountNumber) {
  
  const prefixMap = {

      productionbatches: 'PB',
    
      employees: 'EMP',
    
      qualitycontrolchecks: 'QC',
    
      maintenancerecords: 'MR',
    
      ingredientorders: 'IO',
    
      customerfeedbacks: 'CFB',
    
      bakingschedules: 'BSCH',
    
      bakeryrecipes: 'RECI',
    
      equipments: 'EQP',
    
      ingredients: 'ING',
    
      productionorders: 'PO',
    
      suppliers: 'SUP',
    
      customers: 'CUS',
    
      products: 'PRO',
    
      promotions: 'PRM',
    
      jobapplicants: 'JAP'
};


  const prefix = prefixMap[itemType.toLowerCase()];

  if (!prefix) {
    throw new Error('Invalid item type:'+itemType.toLowerCase());
  }

  let uniqueIdGenerated = false;
  let newId;

  let counter = 0;
  while (!uniqueIdGenerated) {
    // Generate a random number and append to the prefix
    const randomNum = Math.floor(Math.random() * 100000000);
    const accountNumberValue = parseInt(accountNumber).toString();
    newId = `${prefix}${randomNum}_${accountNumberValue}`;


    // Check if the ID already exists in Firestore
    let exists = false;
    try
    {
      const docRef = doc(db, itemType, newId);
      const docSnapshot = await getDoc(docRef);
    
      exists = docSnapshot.exists()

    } catch(error)
    {
      exists = false;
    }

    if (!exists) {
      // ID is unique, save it to Firestore
      //await setDoc(docRef, { type: itemType });
      uniqueIdGenerated = true;
    }

    counter = counter + 1;

    if (counter >= 1000)
    {
      break;
    }
  }

  if (counter >= 20 || !uniqueIdGenerated)
    {
      throw new Error('Unable to generate new id');
    }

  return newId;
}
